import { get } from 'lodash';

const styles = (theme) => ({
  root: {
    margin: "0 36px",
    backgroundColor: get(theme, 'color.uiBackground'),
    padding: "0 36px 100px 36px",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexStart: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
  },
  formSection: {
    maxWidth: "850px",
  },
  optionsContainer: {
    width: "50%",
    maxHeight: "60px",
    marginLeft: "-1.6rem",
  },
  optionFieldContainer: {
    width: "74%",
  },
  flexNonBetween: {
    display: "flex",
    alignItems: "center",
  },
  saveButton: {
    color: get(theme, 'color.primaryButtonText'),
    backgroundColor: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  cancelButton: {
    color: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    '&:focus': {
      border: `3px double ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  requiredFieldLabel: {
    fontWeight: "bold",
    marginTop: "1rem",
  },
  requiredFieldContainer: {
    marginTop: "-1rem",
  },
  dragIcon: {
    color: get(theme, 'color.link'),
    fontSize: "1.8rem",
    cursor: "pointer",
  },
  dragIconButton: {
    marginRight: "-1rem",
  },
  addOptionButton: {
    marginTop: "1rem",
  },
  dropDownTitle: {
    color: get(theme, 'color.bodyText'),
    fontFamily: get(theme, 'typography.bodyText'),
    fontSize: get(theme, 'fontSize.bodyText'),
    fontWeight: "bold",
    marginTop: "2rem",
  },
  dropDownHelpText: {
    fontSize: "0.75rem",
    margin: "0.5rem 0",
  },
  textError: {
    color: get(theme, 'color.error'),
  },
  removeCrossIcon: {
    display: "none",
  },
  deleteSubmitButton: {
    backgroundColor: `${get(theme, 'color.red')} !important`,
    borderColor: `${get(theme, 'color.red')} !important`,
  },
  deleteButton: {
    color: get(theme, 'color.error'),
    borderColor: get(theme, 'color.error'),
    '&:focus': {
      border: `3px double ${get(theme, 'color.error')}`,
    },
  },
  detailsTitile: {
    color: get(theme, 'color.bodyText'),
    fontFamily: get(theme, 'typography.bodyText'),
    fontSize: get(theme, 'fontSize.bodyText'),
    fontWeight: "bold",
  },
  crossIcon: {
    color: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    '&:focus': {
      border: `3px double ${get(theme, 'color.primaryButtonBackground')}`,
    },
    minWidth: "40px",
    height: "40px",
    width: '40px',
  },
})

export default styles;